import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import './index.css'
import App from './App'
import { analysisStore } from './analysis/store'
import ErrorBoundary from './components/ErrorBoundary'

window.addEventListener('error', (event) => {
  console.error('[Global error]', event.error ?? event.message);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('[Unhandled rejection]', event.reason);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
     <ErrorBoundary label="App root">
      <Provider store={analysisStore}>
        <App />
      </Provider>
    </ErrorBoundary>
  </StrictMode>
)
